import React from 'react';
import { connect } from 'react-redux';
import {
  Header,
  Form,
  Container,
  Grid,
  Input,
  Message
} from 'semantic-ui-react';
import { Link, Navigate } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
import get from 'lodash.get';
import ValidatedInput from '../common/validatedInput';
import { authenticate } from '../../modules/session';
import config from '../../constants';
import { hasTextEntryInResources } from '../template/templateHelper';
import './authentication.css';
import { grecaptcha } from '../../helpers/grecaptcha';
import PasskeySignInButton from './PasskeySignInButton';

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    // Local state only — never stored in Redux or any persistent storage
    this.state = {
      email: '',
      password: '',
      remember: false
    };
  }

  onAuthenticate() {
    const { email, password, remember } = this.state;
    const tokenCallback = (token) =>
      this.props.authenticate(email, password, remember, token);
    grecaptcha(tokenCallback, 'login');
  }

  onChange(key, e) {
    this.setState({ [key]: e.target.value });
  }

  onChangeCheckbox(key, e, target) {
    this.setState({ [key]: target.checked });
  }

  isError = () => {
    const session = this.props.session;
    return session.error && session.errorList && session.errorList.length > 0;
  };

  getErrorTranslation = () => {
    const errorList = get(this.props, 'session.errorList');
    if (errorList.length > 1) {
      return errorList.map((item, index) => {
        const currentErrorKey = get(
          this.props,
          `session.errorList.${index}.error`
        );
        const fullKey = `errors.api.${currentErrorKey}`;
        if (hasTextEntryInResources(fullKey)) {
          return I18n.t(fullKey);
        }

        return I18n.t('errors.api.general', {
          errorKey: currentErrorKey,
          fullKey: I18n.t(fullKey)
        });
      });
    }

    const errorKey = get(this.props, 'session.errorList.0.error');
    const fullKey = `errors.api.${errorKey}`;

    if (hasTextEntryInResources(fullKey)) {
      return [I18n.t(fullKey)];
    }

    const generalAuthErrorMessageKey =
      'errors.action.session.AUTHENTICATE_FAILURE';
    return [I18n.t(generalAuthErrorMessageKey)];
  };

  render() {
    // Redirect to MFA verification if pending
    if (this.props.session.mfaPending && this.props.session.pendingSessionToken) {
      const returnParam = new URLSearchParams(window.location.search).get('return');
      const mfaUrl = returnParam
        ? `/verify-mfa?return=${encodeURIComponent(returnParam)}`
        : '/verify-mfa';
      return <Navigate to={mfaUrl} replace />;
    }

    const { email, password } = this.state;

    return (
      <div>
        <div>
          <Header as="h2" textAlign="center">
            {this.props.header}
          </Header>
          <Form
            error={this.isError()}
            onSubmit={() => this.onAuthenticate()}
          >
            <Form.Field>
              <ValidatedInput
                placeholder={I18n.t('authentication.login.emailPlaceholder')}
                name="email"
                id="email"
                value={email}
                onChange={(e) => this.onChange('email', e)}
                label={I18n.t('authentication.login.emailLabel')}
                autoComplete="username email"
              />
            </Form.Field>
            <Form.Field>
              <label htmlFor="password">{I18n.t('authentication.login.passwordLabel')}</label>
              <Input
                placeholder={I18n.t('authentication.login.passwordPlaceholder')}
                name="password"
                id="password"
                autoFocus
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => this.onChange('password', e)}
              />
            </Form.Field>
            <Grid columns={2}>
              <Grid.Column textAlign="left">
                <Form.Checkbox
                  label={I18n.t('authentication.login.rememberMe')}
                  onChange={(e, target) =>
                    this.onChangeCheckbox('remember', e, target)
                  }
                />
              </Grid.Column>
              <Grid.Column textAlign="right" id="forgot-password">
                <Link to="/forgot">{I18n.t('authentication.login.forgotPassword')}</Link>
              </Grid.Column>
            </Grid>
            <Form.Button primary fluid className="login-submit login-button">
              {I18n.t('authentication.login.submit')}
            </Form.Button>
            <PasskeySignInButton remember={this.state.remember} />
            {this.isError() && (
              <Message error list={this.getErrorTranslation()} />
            )}
          </Form>
          <Container textAlign="center" className="login-container">
            <p>
              <strong>{I18n.t('authentication.login.noAccount')}</strong>{' '}
              <a href={config.contactUsUrl}>{I18n.t('authentication.login.contactUs')}</a>
            </p>
          </Container>
        </div>
        <hr className="authentication-divider" />
        <Container textAlign="center">
          <p>
            <strong>{I18n.t('authentication.login.isFundraiser')}</strong>
            <a href={config.fundraiserLoginUrl}> {I18n.t('authentication.login.fundraiserSignIn')}</a>
          </p>
        </Container>
      </div>
    );
  }
}

const mapState = ({ session }) => {
  return {
    session: session
  };
};

const mapDispatch = (dispatch) => {
  return {
    authenticate(email, password, remember, verificationToken = null) {
      dispatch(authenticate(email, password, remember, verificationToken));
    }
  };
};

const LoginFormContainer = connect(mapState, mapDispatch)(LoginForm);
export default LoginFormContainer;
